<div class="h-full w-full surface-50 p-2">
  <p-card class="policy-component block shadow-3">
    <ng-template pTemplate="header">
      <div class="p-card-header flex p-3 gap-2 align-items-center">
        <h3 class="mr-3">{{pageTitle}}</h3>
        <p-select
          [options]="riskSets"
          optionLabel="name"
          [(ngModel)]="selectedRiskSet"
          (onChange)="onRiskSetChanged($event)"
        >
        </p-select>
        <div class="flex align-items-center">
          <p-button
            [text]="true"
            icon="pi pi-plus"
            (click)="createRiskSet()"
          ></p-button>
          <p-button
            *ngIf="selectedRiskSet"
            [text]="true"
            icon="pi pi-trash"
            severity="danger"
            mwlConfirmationPopover
            [title]="'Delete Selected Risk Set'"
            [popoverMessage]="
              'You are going to delete selected risk set. Are you sure?'
            "
            [appendToBody]="true"
            [confirmText]="'Yes'"
            [cancelText]="'No'"
            placement="bottom"
            (confirm)="removeRiskSet()"
          ></p-button>
        </div>
        <input
          type="text"
          pInputText
          [(ngModel)]="selectedRiskSet.name"
          *ngIf="risks"
        />
        <p-button
          [text]="true"
          icon="pi pi-save"
          (click)="saveRiskSet()"
          *ngIf="risks"
        ></p-button>
      </div>
    </ng-template>
    <div class="p-0" *ngIf="risks">
      <p-table
        styleClass="risk-table-striped"
        [value]="groupedRisks[table.type]"
        [columns]="table.columns"
        dataKey="riskId"
        #systemRolesTable
        [tableStyle]="{ 'width': '100%' }"
      >
        <ng-template pTemplate="caption">
          <div class="flex justify-content-end">
            <p-button
              [text]="true"
              icon="pi pi-plus"
              (click)="editRisk({ riskSetId: riskSetId, riskType: table.type })"
            ></p-button>
            <p-button
              [text]="true"
              icon="pi pi-book"
              title="RizkList Report"
              (click)="openRizkListReport()">
            ></p-button>
            <p-button
              [text]="true"
              icon="pi pi-file-excel"
              (click)="systemRolesTable.exportCSV()"
            ></p-button>
            <p-button
              [text]="true"
              icon="pi pi-paperclip"
              (click)="inputVendorFile.click()"
            ></p-button>
            <input #inputVendorFile
                   type="file"
                   (change)="importRisks($event)"
                   [style.display]="'none'">

            <button type="button"
                    pButton
                    class="risksponge-button"
                    icon="pi pi-list"
                    iconPos="left"
                    title="Expand/Collapse all"
                    (click)="toggleItems()"></button>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem"></th>
            <th
              class="font-bold white-space-nowrap"
              style="width: 5%"
              pSortableColumn="riskId"
            >
              Risk ID
              <p-sortIcon
                class="sort-icon"
                field="riskId"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th
              class="font-bold white-space-nowrap"
              style="width: auto"
              pSortableColumn="name"
            >
              Name
              <p-sortIcon
                class="sort-icon"
                field="type"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th
              class="font-bold white-space-nowrap"
              style="width: auto"
              pSortableColumn="type"
            >
              Type
              <p-sortIcon
                class="sort-icon"
                field="type"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th
              class="font-bold white-space-nowrap"
              style="width: auto"
              pSortableColumn="dateRaised"
            >
              Date Raised
              <p-sortIcon
                class="sort-icon"
                field="dateRaised"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th
              class="font-bold white-space-nowrap"
              style="width: auto"
              pSortableColumn="owner"
            >
              Owner
              <p-sortIcon
                class="sort-icon"
                field="owner"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th
              class="font-bold white-space-nowrap"
              style="width: 10%; padding-left: 32px; text-align: center;"
              pSortableColumn="likelihood"
            >
              Likelihood
              <p-sortIcon
                class="sort-icon"
                field="likelihood"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th
              class="font-bold white-space-nowrap"
              style="width: 10%; padding-left: 32px; text-align: center;"
              pSortableColumn="severity"
            >
              Severity
              <p-sortIcon
                class="sort-icon"
                field="severity"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th
              class="font-bold white-space-nowrap"
              style="width: 10%; padding-left: 32px; text-align: center;"
              pSortableColumn="riskValue"
            >
              Risk
              <p-sortIcon
                class="sort-icon"
                field="riskValue"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th
              class="font-bold white-space-nowrap"
              style="width: 10%; padding-left: 32px; text-align: center;"
              pSortableColumn="finalDisposition"
            >
              Disposition
              <p-sortIcon
                class="sort-icon"
                field="finalDisposition"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>

            <th style="width: 3rem"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item let-expanded="expanded">
          <tr [pReorderableRow]="i">
            <td>
              <button
                type="button"
                pButton
                pRipple
                [pRowToggler]="item"
                class="p-button-text p-button-rounded p-button-plain"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
              ></button>
            </td>
            <td style="text-align: center">{{ item.riskId }}</td>
            <td><div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100%;">{{ item.name }} - {{ item.riskDescriptionText }}</div></td>
            <td>{{ item.type }}</td>
            <td>{{ item.dateRaised | date : 'shortDate' }}</td>
            <td>{{ item.owner }}</td>

            <td [title]="item.likelihood">
              <div class="flex justify-content-center">
                <div
                  style="width: 10px; height: 10px; border-radius: 50%"
                  [ngStyle]="{
                    backgroundColor:
                      item.likelihood == 'High'
                        ? 'red'
                        : item.likelihood == 'Medium'
                        ? '#FFC300'
                        : 'green'
                  }"
                ></div>
              </div>
            </td>
            <td [title]="item.severity">
              <div class="flex justify-content-center">
                <div
                  style="width: 10px; height: 10px; border-radius: 50%"
                  [ngStyle]="{
                    backgroundColor:
                      item.severity == 'High'
                        ? 'red'
                        : item.severity == 'Medium'
                        ? '#FFC300'
                        : 'green'
                  }"
                ></div>
              </div>
            </td>
            <td [title]="item.riskValue">
              <div class="flex justify-content-center">
                <div
                  style="width: 10px; height: 10px; border-radius: 50%"
                  [ngStyle]="{
                    backgroundColor:
                      item.severity == 'High'
                        ? 'red'
                        : item.riskValue == 'Medium'
                        ? '#FFC300'
                        : 'green'
                  }"
                ></div>
              </div>
            </td>
            <td>{{ item.finalDisposition }}</td>

            <td>
              <div class="flex align-items-center justify-content-center gap-1">
                <p-button
                  [text]="true"
                  icon="pi pi-pencil"
                  (click)="editRisk(item)"
                ></p-button>
                <p-button
                  [text]="true"
                  icon="pi pi-trash"
                  severity="danger"
                  (click)="deleteRisk(item)"
                ></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="expandedrow" let-item>
          <tr>
            <td colSpan="13">
              <div class="grid">
                <div class="col flex gap-5">
                  <div>
                    <span class="font-semibold">Date Raised:</span>
                    {{ item.dateRaised | date : 'shortDate' }}
                  </div>
                  <div>
                    <span class="font-semibold">Name:</span>
                    {{ item.name }}
                  </div>
                  <div>
                    <span class="font-semibold">Type:</span>
                    {{ item.type }}
                  </div>
                  <div>
                    <span class="font-semibold">Owner:</span>
                    {{ item.owner }}
                  </div>
                </div>
                <div class="col">
                  <div class="flex gap-5">
                    <div>
                      <span class="font-semibold">Likelihood:</span>
                      {{ item.likelihood }}
                    </div>
                    <div>
                      <span class="font-semibold">Severity:</span>
                      {{ item.severity }}
                    </div>
                    <div>
                      <span class="font-semibold">Risk:</span>
                      {{ item.riskValue }}
                    </div>
                  </div>
                </div>
                <div style="margin-right: 30px;">
                  <span class="font-semibold">Disposition:</span>
                  {{ item.finalDisposition }}
                </div>
              </div>

              <div class="grid">
                <div class="col">
                  <div
                    class="flex align-content-center align-items-center gap-2"
                  >
                    <span class="font-bold">Risk Description</span>
                  </div>
                  <div
                    class="ql-editor"
                    [innerHTML]="addToken(item.riskDescription) | sanitizeHtml"
                  ></div>
                </div>
                <div class="col">
                  <div
                    class="flex align-content-center align-items-center gap-2"
                  >
                    <span class="font-bold">Status</span>
                  </div>
                  <div
                    class="ql-editor"
                    [innerHTML]="addToken(item.status) | sanitizeHtml"
                  ></div>
                </div>
                <div class="col">
                  <div
                    class="flex align-content-center align-items-center gap-2"
                  >
                    <span class="font-bold">Impact</span>
                  </div>
                  <div
                    class="ql-editor"
                    [innerHTML]="addToken(item.impact) | sanitizeHtml"
                  ></div>
                </div>
              </div>

              <div class="grid">
                <div class="col">
                  <div
                    class="flex align-content-center align-items-center gap-2"
                  >
                    <span class="font-bold">Mitigation</span>
                  </div>
                  <div
                    class="ql-editor"
                    [innerHTML]="addToken(item.mitigation) | sanitizeHtml"
                  ></div>
                </div>
                <div class="col">
                  <div
                    class="flex align-content-center align-items-center gap-2"
                  >
                    <span class="font-bold">Contingency</span>
                  </div>
                  <div
                    class="ql-editor"
                    [innerHTML]="addToken(item.contingency) | sanitizeHtml"
                  ></div>
                </div>
                <div class="col">
                  <div
                    class="flex align-content-center align-items-center gap-2"
                  >
                    <span class="font-bold">Progress</span>
                  </div>
                  <div
                    class="ql-editor"
                    [innerHTML]="addToken(item.progress) | sanitizeHtml"
                  ></div>
                </div>
              </div>

              <div class="grid" *ngIf="item.relatedControlsList?.length > 0">
                <div class="col">
                  <p-table
                    [value]="item.relatedControlsList"
                    #controls
                    styleClass="risk-table-striped"
                  >
                    <ng-template pTemplate="caption">
                      <div class="flex">
                        <span class="block font-bold">Related Controls</span>
                      </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                      <tr>
                        <th class="font-bold white-space-nowrap">
                          Project name
                        </th>
                        <th class="font-bold white-space-nowrap">
                          Compliance Area
                        </th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-control>
                      <tr>
                        <td>
                          {{ control.projectName }}
                        </td>
                        <td>
                          <a [routerLink]="['/projects/project', control.projectId, control.id]">{{ control.complianceAreaControlId }}</a>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-card>
</div>
